import React from 'react';

/**
 * VotingCard Component - Specialized card for poker voting
 * 
 * @param {string|number} value - Card value to display
 * @param {boolean} selected - Whether this card is selected
 * @param {boolean} revealed - Whether votes are revealed
 * @param {function} onClick - Click handler
 * @param {string} className - Additional CSS classes
 */
const VotingCard = ({
    value,
    selected = false,
    revealed = false,
    onClick,
    className = '',
    ...props
}) => {
    return (
        <div
            onClick={onClick}
            className={`
        relative
        flex items-center justify-center
        w-16 h-24 sm:w-20 sm:h-28
        rounded-xl
        font-bold text-2xl sm:text-3xl
        cursor-pointer
        transition-all duration-200
        backdrop-blur-md
        ${selected
                    ? 'bg-primary text-white border-2 border-primary-light shadow-glow scale-110 z-10'
                    : 'bg-surface hover:bg-surface-hover border border-white/20 hover:border-white/40 text-slate-100 hover:scale-105'
                }
        ${revealed ? 'cursor-default' : ''}
        ${className}
      `}
            {...props}
        >
            <span className="select-none">{value}</span>

            {/* Shine effect on hover */}
            {!selected && !revealed && (
                <div className="absolute inset-0 rounded-xl opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                    <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-white/10 to-transparent" />
                </div>
            )}
        </div>
    );
};

export default VotingCard;
